export const getRandom = <T>(arr: Array<T>): T => {
  const randomIndex = Math.floor(Math.random() * arr.length)
  const randVal = arr[randomIndex]

  return randVal
}

export const uniques = <T extends string | number>(arr: Array<T>): Array<T> => {
  const toObject = arr.reduce((acc, val) => ({ ...acc, [val]: true }), {})
  return Object.keys(toObject) as Array<T>
}
